'use strict';

import angular from 'angular';

import uiRouter from 'angular-ui-router';

import routing from './jdOrder.routes';

import list from './list';
import show from './show';

export default angular.module('onyxReadingRoomApp.jdOrder', [uiRouter, list, show])
  .config(routing)
  .run(function($rootScope) {
    'ngInject';

    $rootScope.$on('$stateChangeStart', function(event, next, nextParams, current) {
      if(next.name === 'logout' && current && current.name && !current.authenticate) {
        next.referrer = current.name;
      }
    });
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/jdOrder/index.js